import { z } from "zod";

/**
 * 产品支持的界面/AI 输出语言。
 * 前后端契约只传稳定 locale code，不传展示文案（ADP-74）。
 */
export const LocaleSchema = z.enum(["en-US", "zh-CN"]);
export type Locale = z.infer<typeof LocaleSchema>;

export const SUPPORTED_LOCALES = LocaleSchema.options;

/** 所有兜底路径的默认语言（浏览器无匹配、缺失 key、AI 无用户上下文） */
export const DEFAULT_LOCALE: Locale = "zh-CN";

/**
 * 把任意 BCP-47 语言标签归一化到受支持的 locale。
 * 例："zh"、"zh-Hans-CN" → "zh-CN"；"en-GB" → "en-US"；无法匹配 → null。
 */
export function matchSupportedLocale(tag: string | null | undefined): Locale | null {
  if (!tag) return null;
  const normalized = tag.toLowerCase();
  if (normalized === "zh-cn" || normalized.startsWith("zh")) return "zh-CN";
  if (normalized === "en-us" || normalized.startsWith("en")) return "en-US";
  return null;
}
